// extracted by mini-css-extract-plugin
export default {"goback":"About_goback__rgVd3"};